<div class="course-pdf-header" [ngClass]="participantClassByRole">
  <div class="logo" [hidden]="llttfPage">
    <img src="assets/u298.png" alt="BB Logo" />
  </div>
  <div class="logo" [hidden]="!llttfPage">
    <img src="assets/lltf_logo.png" alt="LLTTF Logo" />
  </div>

  <div class="close-course">
    <a routerLink="/participants/courses/view-course/{{courseId}}">{{'closeCourseText'|translate:translations}}<fa-icon [icon]="closeIcon"></fa-icon></a>
  </div>
</div>

<div class="course-pdf-body" [class.open]="panel.isOpen">

  <div class="accordion">
    <button class="toggle-view" [class.open]="panel.isOpen" (click)="togglePanel()">
      <div><fa-icon [icon]="chevronRight"></fa-icon></div>
    </button>

    <div class="panel" [class.open]="panel.isOpen">
      <div class="panel-content">

        <div class="course-actions">
          <div class="status-bar">
            <app-course-enrollment-status [course]="course"></app-course-enrollment-status>
            <app-retired-course [course]="course"></app-retired-course>
            <app-favourite-course [course]="course" [userId]="loggedInUserPublicId" (notifyParent)="handleFavouriteClick()"></app-favourite-course>
          </div>
          <div class="h-30"></div>

          <h2>{{course.courseName}}</h2>

          <div class="form-buttons justify">
            <button [hidden]="!isInProgress" class="submit-form-button pv-1-5p" [ngClass]="participantClassByRole" (click)="completeCourse()">{{'markAsCompleteText'|translate:translations}}</button>
            <button [hidden]="isInProgress" class="submit-form-button pv-1-5p" [ngClass]="participantClassByRole" (click)="reOpenCourse()">{{'markAsInProgressText'|translate:translations}}</button>
            <button class="submit-form-button cancel-button pv-1-5p" [ngClass]="participantClassByRole" (click)="createPlan()">{{'createAPlanHeadingText'|translate:translations}}</button>
          </div>
        </div>

        <div class="course-materials">
          <mat-accordion>
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <fa-icon [icon]="faBars"></fa-icon> {{'courseContentsText'|translate:translations}}
                </mat-panel-title>
              </mat-expansion-panel-header>

              <h3>Course E-book</h3>
              <ul>
                @for (ebookMaterial of ebookMaterials; track ebookMaterial) {
                  <li>
                    <a (click)="loadPDFFile(ebookMaterial.id)" [ngClass]="ebookMaterial.id == materialId ? 'current-pdf' : ''">{{ebookMaterial.materialName}}</a>
                    @if (ebookMaterial.isMaterialRetired) {
                      <span class="material-retired-meta">
                        <span class="material-retired-tag">{{ 'materialRetiredBadge' | translate: translations }}</span>
                        <app-information-popup [information]="materialRetiredPopupHtml(ebookMaterial)"></app-information-popup>
                      </span>
                    }
                  </li>
                }
              </ul>


              @if (streamCourseMaterials.length > 0) {
                <span>
                  <h3>Course Media</h3>
                  <ul>
                    @for (media of streamCourseMaterials; track media) {
                      <li>
                        <a (click)="loadPDFFile(media.id)" [ngClass]="media.id == materialId ? 'current-pdf' : ''">{{media.materialName}}</a>
                        @if (media.isMaterialRetired) {
                          <span class="material-retired-meta">
                            <span class="material-retired-tag">{{ 'materialRetiredBadge' | translate: translations }}</span>
                            <app-information-popup [information]="materialRetiredPopupHtml(media)"></app-information-popup>
                          </span>
                        }
                      </li>
                    }
                  </ul>
                </span>
              }

              @if (otherCourseMaterials.length > 0) {
                <span>
                  <h3>Supplementary Worksheets</h3>
                  <ul>
                    @for (content of otherCourseMaterials; track content) {
                      <li>
                        <a (click)="loadPDFFile(content.id)" [ngClass]="content.id == materialId ? 'current-pdf' : ''">{{content.materialName}}</a>
                        @if (content.isMaterialRetired) {
                          <span class="material-retired-meta">
                            <span class="material-retired-tag">{{ 'materialRetiredBadge' | translate: translations }}</span>
                            <app-information-popup [information]="materialRetiredPopupHtml(content)"></app-information-popup>
                          </span>
                        }
                      </li>
                    }
                  </ul>
                </span>
              }
              <div class="clear"></div>

            </mat-expansion-panel>
          </mat-accordion>
        </div>


        <div class="course-notes">
          <mat-accordion>
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <fa-icon [icon]="faBars"></fa-icon> {{'notesText'|translate:translations}}
                </mat-panel-title>
              </mat-expansion-panel-header>

              <app-note></app-note>

              <div class="clear"></div>

            </mat-expansion-panel>
          </mat-accordion>
        </div>

        <div class="panel-footer">
          <p>{{'courseProgressSavedNoteText'|translate:translations}}</p>
        </div>
      </div>
    </div>
  </div>

  <div class="pdf-content" [class.close]="panel.isOpen">
    <app-pdf-viewer [materialId]="materialId"></app-pdf-viewer>
  </div>
</div>
